// --- React
import React from "react";
// --- Actions & Hooks
import { useDialogsActions } from "../hooks";
import { useDialogsForm } from "../forms";
// --- External UI Libraries
import { FileUploader } from "@dtci/spellbook/FileUploader";
import Button from "@dtci/spellbook/Button";

const TEMPLATE_PATHS = {
  rateCard: "/upload_templates/RateCard.xlsx",
  licensingJob: "/upload_templates/LicensingJob.xlsx",
};

const UploadForm = ({ pageName }) => {
  const form = useDialogsForm();
  const templatePath = TEMPLATE_PATHS[pageName];

  const fileUploadHandler = async (fileList, rawFiles) => {
    try {
      let rawFile = [];
      for (let i = 0; i < rawFiles.length; i++) {
        const file = rawFiles[i];
        if (
          fileList.find(
            (currentFile) => file.name === currentFile.name && currentFile.new,
          )
        ) {
          rawFile.push(file);
        }
      }
      form.setValue("file", rawFile);
    } catch (error) {
      throw new Error("Function not implemented.");
    }
  };

  return (
    <div>
      <FileUploader
        deleteFileConfirmationModal={{
          text: "Are you sure you want to delete this file?",
          title: "Delete File",
        }}
        displayFiles="list"
        labelText="Choose Files"
        multiple
        value={form.state.formData?.file}
        handleFileUpload={fileUploadHandler}
      />
      {templatePath && (
        <Button
          styleType="link"
          iconType="fa-solid fa-download"
          labelText="Download Template"
          onClick={() => {
            const link = document.createElement("a");
            link.href = templatePath;
            link.download = templatePath.split("/").pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
        >
          Download Template
        </Button>
      )}
    </div>
  );
};

/**
 * Hook to manage file upload dialogs.
 * @returns {{ openUploadDialog: (data: any, onConfirm: Function, pageName?: string) => void }}
 */
export const useUploadDialog = () => {
  const { openDialog, closeDialog } = useDialogsActions();
  const form = useDialogsForm();

  const handleSubmit = (onSubmit) => () => {
    onSubmit(form.state.formData);
    form.reset();
    closeDialog();
  };

  const openUploadDialog = (data, onConfirm, pageName = "") =>
    openDialog({
      title: `File Upload View`,
      content: <UploadForm pageName={pageName} />,
      closeAction: true,
      primaryAction: {
        label: "Upload",
        action: handleSubmit(onConfirm),
      },
    });

  return { openUploadDialog };
};
